import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({
  showSpinner: false
})

import router from "@/router"
import store from '@/store/index.js'
import { getToken } from "@/utils/cookies"
console.log(store.state);
//需要登录才能访问的页面路由
const checklist = ['/home/controlSysMsg','/home/orderDetail','/home/controldocument','/home/controldetail','/controlhome','/home/controlsyshome','/home/controlsupport','/home/controlinformation','/home/controlrealauth','/home/controlenterauth','/home/controluserauth','/downloads']
router.beforeEach(async (to, _from, next) => {
    NProgress.start()
    window.scrollTo({ top: 0});
    console.log(navigator.onLine, to.path);
    if (navigator.onLine) {//判断网络状态
        if (to.path == '/home/nonetwork') {
            next({ path: _from.path })
            // console.log( _from.path);
        } else {
            // console.log(_from,111);
            if (checklist.includes(to.path)) {
                if (store.state.user.islogin&&getToken()) {
                    next();
                } else {
                    next('/login')
                }
            } else {
                next()
            }

        }
    } else {
        // console.log('12323',to.path);
        if (to.path !== '/home/nonetwork') {
            next({ path: '/home/nonetwork' })
        } else {
            next()
        }
    }
})

router.afterEach((to, form) => {
    NProgress.done()
})